import { render, staticRenderFns } from "./CollapsibleBox.vue?vue&type=template&id=b33bddbc&scoped=true&"
import script from "./CollapsibleBox.vue?vue&type=script&lang=ts&"
export * from "./CollapsibleBox.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsibleBox.vue?vue&type=style&index=0&id=b33bddbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33bddbc",
  null
  
)

export default component.exports